import Seo from './seo';

export default Seo;
